<app-pagetitle [title]="'Grupos de Orçamento'" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
  <div class="col-lg-12">
    <!-- Card principal -->
    <div class="card">
      <!-- Cabeçalho do card -->
      <div class="card-header">
        <div class="col-12 d-flex align-items-center">
          <div class="col-9">
            <h4 class="card-title">Confira Explicações</h4>
            <p class="card-title-desc">
              Se colocado <code class="text-uppercase">Incluir ao documento</code> como
              <code>Ativo/Ligado</code> a categoria será inclusa ao documento Proposta Comercial.
            </p>
            <p class="card-title-desc">
              Se colocado <code class="text-uppercase">Apresentação</code> como
              <code>Apresentação Detalhada</code> será adicionado todos os itens pertencentes a categoria ao documento
              Proposta Comercial.
            </p>

            <p class="card-title-desc">
              Se colocado <code class="text-uppercase">Apresentação</code> como
              <code>Apresentação Resumida</code> será adicionado apenas a quantidade de itens dentro da categoria ao
              documento Proposta Comercial.
            </p>
          </div>
          <div class="col-3 d-flex justify-content-end">
            @if(!podeEditar){
            <button disabled type="text" title="Sem permissão" class="btn btn-light waves-effect">
              <i class="bx bx-block btn-sm font-size-16 align-middle me-2"></i>Adicionar
            </button>
            }@else {
            <button (click)="registerNewBudgetParameter()" class="btn btn-primary w-md">Nova Categoria</button>
            }
          </div>
        </div>
        <div class="col-12 mt-3 align-items-start">
          @if(!modoEdicaoInput){
            <button class="btn btn-outline-primary btn-sm me-2" (click)="habilitarEdicao()">Editar Ordem</button>
          }@else{
            <button class="btn btn-sm btn-outline-light waves-effect me-2" (click)="cancelarEdicaoOrdem()" >Cancelar</button>
            <button class="btn btn-success btn-sm" (click)="salvarOrdem()" >Salvar Ordem</button>
          }
        </div>
      </div>
      @if (error || erro403) {
      @if(erro403){
      <app-no-access></app-no-access>
      }@else{

      <div class="col-12">
        <div class="alert alert-danger" role="alert">{{ error }}</div>
      </div>
      }
      } @else {
      <!-- Corpo do card -->
      <div class="card-body">
        <form #budgetForm="ngForm">
          <div class="table-responsive">
            <table class="table mb-0 table-striped">
              <thead>
                <tr>
                  <th style="width: 70px;">Orden</th>
                  <th>Categoria</th>
                  <th>Tipo De Despesa</th>
                  <th>Incluir ao documento</th>
                  <th>Apresentação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                @if (budgetService.loading) {
                <tr>
                  <td colspan="5" class="text-center position-relative">
                    <div class="d-flex justify-content-center align-items-center" style="height: 150px">
                      <span class="spinner-border" style="width: 3rem; height: 3rem" role="status"
                        aria-hidden="true"></span>
                    </div>
                  </td>
                </tr>
                } @else {
                
                <tr *ngFor="let row of groups; let i = index">
                  <th>
                    <input type="number"
                      class="col-12"
                      [name]="'orden' + i"
                       [(ngModel)]="row.ordem"
                      value="{{row.ordem}}"
                      [disabled]="!modoEdicaoInput" style="width: 50px; padding-left: 1px; padding-right: 1px;">
                  </th>
                  <td>
                    {{ row.nome}}
                  </td>
                  <td>
                    {{ row.tipoDeDespesa == 1? 'Materiais' : 'Operacional'}}
                  </td>
                  <td [ngSwitch]="row.apresentarEmOrcamento">
                    <span class="badge bg-success-subtle text-success p-2" *ngSwitchCase=true>Sim</span>
                    <span class="badge bg-danger-subtle text-danger p-2" *ngSwitchCase=false>Não</span>
                  </td>
                  <td [ngSwitch]="row.tipoDeApresentacao">
                    <span class="badge bg-primary-subtle text-primary p-2" *ngSwitchCase="1">Detalhada</span>
                    <span class="badge bg-primary-subtle text-primary p-2" *ngSwitchCase="2">Resumida</span>
                    <span class="badge bg-danger-subtle text-danger p-2" *ngSwitchCase="0">Não Apresentar</span>
                  </td>
                  <td>
                    <div class="dropdown" ngbDropdown>
                      @if(!podeEditar){
                      <i title="Sem permissão" class="bx bx-block font-size-16 align-middle"></i>
                      }@else {
                      <button class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                        type="button" ngbDropdownToggle aria-expanded="false">
                        <i class="bx bx-dots-horizontal-rounded"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                        <li>
                          <a class="dropdown-item" href="javascript:void(0);"
                            [routerLink]="['/telemarketing/projetos/configuracoes/parametros-orcamento', row.id]">
                            Editar
                          </a>
                          <button class="dropdown-item" href="javascript:void(0);" (click)="openModalDelete(row)"
                            data-bs-target="#staticBackdrop" data-bs-toggle="modal">
                            Excluir
                          </button>
                        </li>

                      </ul>
                      }
                    </div>
                  </td>
                </tr>
                
                }
              </tbody>
            </table>
          </div>

          <!-- Botões de ação -->
          <div class="d-flex mt-3">
            <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
            <!-- <button type="submit" class="btn btn-success w-md ms-2">Salvar</button> -->
          </div>
        </form>
      </div>
      <!-- Fim do corpo do card -->
      }
    </div>

    <!-- Fim do card principal -->
  </div>
</div>

<app-modal-excluir [title]="'Excluir Modelo de Documento'"
  [text]="'Modelo de documento será excluído definitivamente. Deseja continuar?'"
  (confirmDelete)="handleDelete($event)">
</app-modal-excluir>